import React,{useState} from 'react'
import {FiPlusCircle}  from 'react-icons/fi'  
import PortalDataTable from "../../../components/PortalDataTable";

import { SearchBox, Modal } from "../../../components";
import { formCategoryColumns } from "../../../utils";
import {useGetFormCategories} from '../../../hooks/formCategories/useGet'
import CreateFormCategory from '../../../forms/create/CreateFormCategory';
import NetworkError from '../../../components/NetworkError';

const FormCategories = () => {
    const {data,isLoading,isError,error}=useGetFormCategories();

    const [toggleModal,setToggleModal] = useState(false)
  
    const handleModalToggle=()=>{
         setToggleModal(prevState=>!prevState);
    }

  
    if (isError && error.code === 'ERR_NETWORK') {
      return (
          <NetworkError error={error}/>
      )
    }
    
    if(isError) return <span>Oops something happened....</span>
    return (
      <div className="w-full flex flex-col px-10">
        <div className="branch_header">
          <div className="branch_header_title_group">
            <div className="branch_header_title_main">Form Categories</div>
            {!isLoading&&<div className="branch_header_title_sub"> {data?.length==0?'No ':data.length} users</div>}
          </div>
          <div className="branch_header_buttons_group">
            <div
              onClick={handleModalToggle}
              className="branch_header_buttons_right bg-[#0E86D4]"
            >
              <FiPlusCircle style={{ marginRight: "10px" }} />
              New Category
            </div>
          </div>
        </div>
        {/* <SearchBox /> */}
        <Modal title='Create Category' form={<CreateFormCategory/>} toggleModal={toggleModal} handleToggle={handleModalToggle} />
        <PortalDataTable cols={formCategoryColumns} loading={isLoading} rows={data} />
      </div>
    );
  };


export default FormCategories
